import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  checkbox: {
    width: '100%'
  },
  select: {
    width: '100%',
    marginBottom: 24
  },
  dateTimePicker: {
    width: '100%',
    marginBottom: 24
  },
  textField: {
    marginBottom: 24
  }
}))

export default useStyles
